import styled from 'styled-components';

export const FarelockBtn = styled.button`
  background: linear-gradient(
    to right,
    #802d00,
    #d37e41 70%,
    #fbb076 78%,
    #d68044 87%,
    #792c00 93%
  );
  border-radius: 4px;
  color: #122dff;
  display: inline-block;
  padding: ${props => props.theme.spacing.custom(2)};
  text-decoration: none;
  border: none;
  font-size: ${props => props.theme.font.custom(14)};
  width: 100%;
  cursor: pointer;
  margin-bottom: 5px;
  margin-right: ${props => props.theme.spacing.custom(10)};
  .btnText {
    background: #fff;
    border-radius: 2px;
    color: #8b3c11;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 0;
    width: 100%;
  }
  .farelockTip {
    background: #fff;
    box-shadow: 0px 0px 11px #ddd;
    border-radius: 7px;
    width: 335px;
    position: absolute;
    bottom: 50px;
    right: 10px;
    padding: ${props => props.theme.spacing.custom(8)} ${props => props.theme.spacing.custom(15)};
    font-size: ${props => props.theme.font.custom(14)};
    display: block;
    text-align: left;
    color: #000;
    display: none;
    line-height: 20px;
    ::before {
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid #fff;
      content: '';
      position: absolute;
      bottom: -10px;
      right: 30px;
      z-index: 1;
    }
    ::after {
      width: 0;
      height: 0;
      border-left: 11px solid transparent;
      border-right: 11px solid transparent;
      border-top: 11px solid #eee;
      content: '';
      position: absolute;
      bottom: -12px;
      right: 29px;
    }
  }

  :hover .farelockTip {
    display: block;
  }
`;
export const FarelockListingOuter = styled.div`
  position:relative;
}

`;
export const FarelockOverlay = styled.div`
  width: 480px;
  background: #fff;
  position: absolute;
  right: 110px;
  top: -20px;
  box-shadow: 0 8px 40px 10px rgb(112 144 176 / 15%);
  padding: 24px 24px;
  border-radius: 7px;
  z-index: 1;

  ::before {
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-left: 10px solid #fff;
    border-bottom: 10px solid transparent;
    content: '';
    position: absolute;
    top: 26px;
    right: -9px;
    z-index: 1;
  }
  ::after {
    width: 0;
    height: 0;
    border-top: 11px solid transparent;
    border-left: 11px solid #eee;
    border-bottom: 11px solid transparent;
    content: '';
    position: absolute;
    top: 25px;
    right: -11px;
  }
`;
export const FarelockOveralayTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
`;

export const FarelockHead = styled.span`
  font-size: ${props => props.theme.font.custom(22)};
  color: #333333;
  font-weight: 700;
  font-family: 'Quicksand';
`;
export const PaylockButton = styled.button`
  background-color: #ff6d38;
  border-radius: 0.5rem;
  outline: none;
  padding: ${props => props.theme.spacing.custom(7)} 0;
  color: #ffffff;
  ${props => props.theme.quicks};
  /* text-transform: capitalize; */
  border: none;
  font-weight: bold;
  font-size: ${props => props.theme.font.custom(16)};
  width: 100%;
  padding: ${props => props.theme.spacing.custom(10)};
  margin-top: ${props => props.theme.spacing.custom(25)};
  cursor: pointer;
  a {
    text-decoration: none;
    color: #ffffff;
  }
`;
